import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'tooltip-input',
    templateUrl: './tooltip-input.component.html',
    styleUrls: ['./tooltip-input.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class TooltipInputComponent {
    @Input('styleInput') styleInput: boolean = true;
    constructor() { }
}
